export default __webpack_public_path__ + "static/media/property_808.6a93c863.png";